import { Upload } from "@commonlibs";
import styled, { css } from "styled-components";

export const UploadInputRoot = styled(Upload)(
    () => css`
        &.isLoading {
            pointer-events: none;
        }
    `,
);
